import React from 'react';

const AppsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="38"
    viewBox="0 0 24 38"
  >
    <g fill="none">
      <path d="M0.5 32.6L0.5 32.7 0.5 4.9C0.5 3.6 1 2.5 1.9 1.6 2.8 0.7 3.8 0.3 5.1 0.3L19 0.3C20.3 0.3 21.4 0.7 22.3 1.6 23.2 2.5 23.6 3.6 23.6 4.9L23.6 32.6C23.6 33.9 23.2 35 22.3 35.9 21.4 36.8 20.3 37.3 19 37.3L5.1 37.3C3.8 37.3 2.8 36.8 1.9 35.9 1 35 0.5 33.9 0.5 32.6ZM2.8 26.9C2.8 27.2 2.9 27.5 3.1 27.7 3.4 27.9 3.6 28 3.9 28L20.1 28.1C20.5 28 20.7 27.9 20.9 27.7 21.2 27.4 21.3 27.2 21.3 26.9L21.3 8.3C21.3 8.1 21.2 7.8 20.9 7.5 20.7 7.3 20.5 7.2 20.1 7.2L3.9 7.3C3.6 7.2 3.4 7.3 3.1 7.6 2.9 7.8 2.8 8 2.8 8.4L2.8 26.9ZM7.4 3.8L7.4 3.8C7.4 4.1 7.5 4.4 7.8 4.6 8 4.8 8.2 5 8.5 5 8.9 5 9.1 4.8 9.3 4.6 9.6 4.4 9.7 4.1 9.7 3.8 9.7 3.5 9.6 3.2 9.3 3 9.1 2.7 8.9 2.6 8.5 2.7 8.2 2.6 8 2.7 7.8 3 7.5 3.2 7.4 3.5 7.4 3.8ZM9.8 33.8L9.8 33.9C9.7 34.3 9.8 34.5 10.1 34.7 10.3 35 10.6 35.1 10.9 35L13.2 35.1C13.5 35 13.8 34.9 13.9 34.8 14.2 34.5 14.4 34.2 14.3 33.9L14.4 31.5C14.3 31.3 14.2 31 14 30.7 13.7 30.6 13.5 30.5 13.3 30.4L10.9 30.5C10.6 30.4 10.3 30.5 10 30.8 9.8 31 9.7 31.2 9.7 31.6L9.8 33.8ZM12 4.4C12 4.8 12.2 5 12.6 5.1L16.1 5C16.5 5 16.6 4.8 16.7 4.4 16.6 4 16.5 3.9 16.1 3.8L12.6 3.9C12.2 3.8 12 4 12 4.4Z" />
    </g>
  </svg>
);

export default AppsIcon;
